import { render, staticRenderFns } from "./Reddit.vue?vue&type=template&id=4021314e&scoped=true&"
import script from "./Reddit.vue?vue&type=script&lang=js&"
export * from "./Reddit.vue?vue&type=script&lang=js&"
import style0 from "./Reddit.vue?vue&type=style&index=0&id=4021314e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021314e",
  null
  
)

export default component.exports